import { Link, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import axios from 'axios';

const API_URL = '/backend/api/';  // ← Voeg deze regel toe

function AdminDashboard() {
  const navigate = useNavigate();

  // Bescherming: als niet ingelogd, terug naar login
  useEffect(() => {
    if (localStorage.getItem('isAdmin') !== 'true') {
      navigate('/admin/login');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('isAdmin');
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="max-w-4xl mx-auto">
        <div className="flex justify-between items-center mb-12">
          <h1 className="text-4xl font-bold">Admin Dashboard</h1>
          <button
            onClick={handleLogout}
            className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-lg font-bold"
          >
            Uitloggen
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <Link
            to="/admin/generate"
            className="bg-white rounded-xl shadow-lg p-8 text-center hover:shadow-2xl transition"
          >
            <div className="text-6xl mb-4">🎫</div>
            <h2 className="text-2xl font-bold mb-2">Quiz aanmaken & codes genereren, afblijven ;-)</h2>
            <p className="text-gray-600">Nieuwe quiz starten en teamcodes maken</p>
          </Link>

          <Link
            to="/admin/controller"
            className="bg-white rounded-xl shadow-lg p-8 text-center hover:shadow-2xl transition"
          >
            <div className="text-6xl mb-4">▶️</div>
            <h2 className="text-2xl font-bold mb-2">Ronde Controller</h2>
            <p className="text-gray-600">Rondes activeren, afsluiten en nakijken</p>
          </Link>

          <Link
            to="/admin/scoring"
            className="bg-white rounded-xl shadow-lg p-8 text-center hover:shadow-2xl transition"
          >
            <div className="text-6xl mb-4">✏️</div>
            <h2 className="text-2xl font-bold mb-2">Antwoorden nakijken</h2>
            <p className="text-gray-600">Scores toekennen per vraag</p>
          </Link>

          <Link
            to={`${API_URL}export_scores_excel.php`}
            target="_blank"
            className="bg-white rounded-xl shadow-lg p-8 text-center hover:shadow-2xl transition"
            >
            <div className="text-6xl mb-4">📊</div>
            <h2 className="text-2xl font-bold mb-2">Excel export scores</h2>
            <p className="text-gray-600">Download volledige puntentelling van alle rondes</p>
            </Link>

            <Link
            to="/admin/teams"
            className="bg-white rounded-xl shadow-lg p-8 text-center hover:shadow-2xl transition"
            >
            <div className="text-6xl mb-4">👥</div>
            <h2 className="text-2xl font-bold mb-2">Teams & Codes</h2>
            <p className="text-gray-600">Overzicht van alle teams en toegangscodes</p>
            </Link>

          {/* Voeg later scoreboard toe */}
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;